export const selfName = 'I made this for my own accounts';
